import useGetConnectedAccount from './useGetConnectedAccount'

export default useGetConnectedAccount
